/**
 * Notice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The Province model module.
 * @module model/Province
 * @version 1.0
 */
class Province {
    /**
     * Constructs a new <code>Province</code>.
     * @alias module:model/Province
     */
    constructor() { 
        
        Province.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>Province</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Province} obj Optional instance to populate.
     * @return {module:model/Province} The populated <code>Province</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Province();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }


}

/**
 * Class Province
 * @member {Number} id
 */
Province.prototype['id'] = undefined;

/**
 * Class Province
 * @member {String} name
 */
Province.prototype['name'] = undefined;






export default Province;

